import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Grow,
  Box,
  Button,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

export const AgentCreatedCredentials = ({ open, onClose, credentials }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [copiedField, setCopiedField] = useState(null);

  useEffect(() => {
    if (open) {
      setShowPassword(false);
      setCopiedField(null);
    }
  }, [open]);

  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (error) {
      console.error("Error copying to clipboard:", error);
    }
  };

  const handleCopyAll = async () => {
    const content = `Correo: ${credentials.email}\nContraseña: ${credentials.temporary_password}`;
    await handleCopy(content, "all");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (!credentials) return null;

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Grow}
      transitionDuration={500}
      PaperProps={{
        sx: {
          borderRadius: 2,
          marginTop: 10,
        },
        style: {
          zIndex: 1600,
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
          pt: 0.5,
        }}
      >
        <Typography variant="h3" sx={{ py: 2 }}>
          Agente Creado Exitosamente
        </Typography>

        <IconButton
          aria-label="cerrar"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: (theme) => theme.palette.grey[700],
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 2,
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Comparta estas credenciales con el nuevo agente:
          </Typography>

          <Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                mb: 0.8,
                color: (theme) => theme.palette.text.primary,
              }}
            >
              Correo Electrónico
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={credentials.email}
              inputProps={{ readOnly: true }}
              variant="outlined"
            //   InputProps={{
            //     endAdornment: (
            //       <InputAdornment position="end">
            //         <Tooltip title={copiedField === "email" ? "Copiado" : "Copiar"}>
            //           <IconButton
            //             edge="end"
            //             onClick={() => handleCopy(credentials.email, "email")}
            //             sx={{ mr: 0.5 }}
            //             size="small"
            //           >
            //             {copiedField === "email" ? (
            //               <CheckIcon sx={{ color: "success.main" }} fontSize="small" />
            //             ) : (
            //               <ContentCopyIcon fontSize="small" />
            //             )}
            //           </IconButton>
            //         </Tooltip>
            //       </InputAdornment>
            //     ),
            //   }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                },
              }}
            />
          </Box>

          <Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                mb: 0.8,
                color: (theme) => theme.palette.text.primary,
              }}
            >
              Contraseña Temporal
            </Typography>
            <TextField
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              value={credentials.temporary_password}
              inputProps={{ readOnly: true }}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={showPassword ? "Ocultar" : "Mostrar"}>
                      <IconButton
                        edge="end"
                        onClick={togglePasswordVisibility}
                        size="small"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon fontSize="small" />
                        ) : (
                          <VisibilityIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>
                    {/* <Tooltip
                      title={copiedField === "password" ? "Copiado" : "Copiar"}
                    >
                      <IconButton
                        edge="end"
                        onClick={() =>
                          handleCopy(credentials.temporary_password, "password")
                        }
                        sx={{ mr: 0.5 }}
                        size="small"
                      >
                        {copiedField === "password" ? (
                          <CheckIcon
                            sx={{ color: "success.main" }}
                            fontSize="small"
                          />
                        ) : (
                          <ContentCopyIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip> */}
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                },
              }}
            />
          </Box>

          {/* Info Alert */}
          <Box
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === "dark"
                  ? "rgba(33, 150, 243, 0.1)"
                  : "rgba(33, 150, 243, 0.08)",
              border: "1px solid",
              borderColor: (theme) =>
                theme.palette.mode === "dark"
                  ? "rgba(33, 150, 243, 0.3)"
                  : "rgba(33, 150, 243, 0.2)",
              borderRadius: 1,
              p: 1.5,
              mt: 1,
            }}
          >
            <Typography variant="caption" color="textSecondary">
              El agente deberá cambiar su contraseña en el primer inicio de sesión.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          p: 2,
          pt: 1,
          px: 3,
          flexDirection: "column",
          gap: 2,
          alignItems: "stretch",
        }}
      >
        <Button
          variant="contained"
          onClick={handleCopyAll}
          startIcon={
            copiedField === "all" ? (
              <CheckIcon fontSize="small" sx={{ color: "success.main" }} />
            ) : (
              <ContentCopyIcon fontSize="small" />
            )
          }
          fullWidth
        >
          Copiar correo y contraseña
        </Button>
        <Box sx={{  width: "100%", pt: 1 }}>
            <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            fullWidth
            >
            Listo
            </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
